// @flow
import React from "react";
import fileDownload from "js-file-download";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import I18n from "../i18n/I18n";
import { put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

export default (api: Object) => {


  /* GET BADGE */

  function* getImportAsnBatches(action) {
    try {
      const response = yield call(api.imports.getImportAsnBatches, action.query);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.getAsnBatchesImportSuccess(response.data));
      } else {
        yield put(Actions.getAsnBatchesImportFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getAsnBatchesImportFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchGetImportAsnBatches(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ASN_BATCHES_IMPORT, getImportAsnBatches);
  }

  // GET STOCK BATCHES
  function* getStockAsnBatches(action) {
    try {
      const response = yield call(api.imports.getStockAsnBatches, action.query);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.getAsnBatchesStockSuccess(response.data));
      } else {
        yield put(Actions.getAsnBatchesStockFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getAsnBatchesStockFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchGetStockAsnBatches(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ASN_BATCHES_STOCK, getStockAsnBatches);
  }

  function* getImportLines(action) {
    try {
      const response = yield call(api.imports.getImportLines, action.query);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        if(action.isExport) {
            fileDownload(response.data, `partner-sku-unique.csv`);
        }
        yield put(Actions.getImportLinesSuccess(response.data));
      } else {
        yield put(Actions.getAsnBatchesImportFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getImportLinesFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchGetImportLines(): Generator<void, void, void> {
    yield takeLatest(Types.GET_IMPORT_LINES, getImportLines);
  }

  function* getStockLines(action) {
    try {
      const response = yield call(api.imports.getStockLines, action.query);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        if(action.isExport) {
            fileDownload(response.data, `partner-sku-unique.csv`);
        }
        yield put(Actions.getStockLinesSuccess(response.data));
      } else {
        yield put(Actions.getStockLinesFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getStockLinesFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchGetStockLines(): Generator<void, void, void> {
    yield takeLatest(Types.GET_STOCK_LINES, getStockLines);
  }

  /* Export PSKU */

  function* exportStock(action) {
    try {
      const response = yield call(api.imports.exportStock);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.exportStockSuccess(response.data));
        fileDownload(response.data, "offer-stock.csv");
      } else {
        yield put(Actions.exportStockFailure(response.data.error));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportStockFailure(error));
      toast(error, { type: "error", className: "errorClass" });
    }
  }
  function* watchExportStock(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_STOCK, exportStock);
  }

  /* import Stock */

  function* importStock(action) {
    try {
      const response = yield call(
        api.imports.importStock,
        action.stock
    );
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.importStockSuccess(response.data));
        //yield put(Actions.getOfferCount());
        yield put(Actions.getAsnBatchesStock());
      } else {
        yield put(Actions.importStockFailure(response.data.error));
        toast(response.data.error || "Something went wrong", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.importStockFailure(error));
    }
  }
  function* watchImportStock(): Generator<void, void, void> {
    yield takeLatest(Types.IMPORT_STOCK, importStock);
  }

  return {
    watchGetImportAsnBatches,
    watchGetStockAsnBatches,
    watchGetImportLines,
    watchGetStockLines,
    watchExportStock,
    watchImportStock
  };
};



// WEBPACK FOOTER //
// ./src/sagas/ImportSaga.js